export default "__VITE_ASSET__eb5eef36__"